import useBlazeSlider from '@/utils/useBlazeSlider';
import { SliderCard } from './SliderCard';

export function Slider({ cards, discountType, addSelectedProducts }) {
  const elRef = useBlazeSlider({
    all: {
      slidesToShow: cards?.length,
      slideGap: '16px',
      loop: false
    },
    '(max-width: 768px)': {
      slidesToShow: 1
    }
  });

  return (
    <div className={`blaze-slider relative`} ref={elRef}>
      <div className="blaze-container mx-auto justify-center sm:flex">
        <div className="blaze-track-container flex w-screen overflow-x-hidden">
          <div className={`blaze-track w-57.5 md:justify-start`} tabIndex={0}>
            {cards.map((card, index) => {
              return (
                <SliderCard
                  key={index}
                  card={card}
                  discountType={discountType}
                  addSelectedProducts={addSelectedProducts}
                />
              );
            })}
          </div>
        </div>
      </div>
      <div className="blaze-pagination indicators-light mb:mb-0 mt-5 mb-7 flex md:mt-8"></div>
    </div>
  );
}
